import { size, __spreadValues } from './chunk-JJ6VZ5V7.mjs';
import * as React from 'react';
import styled, { color } from '@xstyled/styled-components';

var SvgComponent = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  __spreadValues({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24px",
    height: "24px",
    fill: "none",
    viewBox: "0 0 48 48"
  }, props),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "currentColor",
      fillRule: "evenodd",
      d: "M24.06 9C31.732 9 38.063 14.735 39 22.153a4.427 4.427 0 0 0-1.476-.584c-1.169-6.37-6.752-11.2-13.464-11.2-7.563 0-13.69 6.129-13.69 13.69 0 6.666 4.761 12.218 11.069 13.44l.038.16c.139.487.343.92.626 1.333C14.71 38.035 9 31.715 9 24.06 9 15.742 15.741 9 24.06 9Zm10.37 22.638.596.62v-.001l.544.563 2.496 2.585c.35.364.489.608.565.875.076.268.071.54-.014.805-.085.265-.232.504-.595.855l-.31.3c-.364.35-.608.488-.876.564a1.36 1.36 0 0 1-.804-.014c-.265-.085-.504-.231-.855-.595l-2.043-2.115-.957-.994-.637-.658-2.45 2.37-.913.877-.403.39c-.364.352-.607.49-.875.566l-.161.036-.162.017a1.374 1.374 0 0 1-.482-.067c-.227-.073-.435-.191-.71-.453l-.145-.142-.29-.3-.009-.01c-.351-.364-.49-.608-.565-.876a1.368 1.368 0 0 1 .014-.804c.085-.265.232-.504.595-.855l3.766-3.638-.496-.514-3.14-3.251c-.352-.364-.49-.607-.566-.875a1.368 1.368 0 0 1 .014-.805c.073-.227.191-.435.453-.71l.143-.145.31-.299c.363-.351.607-.49.875-.565.107-.03.215-.048.322-.053l.162.003c.108.008.215.03.32.064.266.085.504.232.855.595l3.637 3.765 3.766-3.636c.364-.35.608-.489.875-.565.268-.076.54-.071.805.014.206.066.395.17.634.382l.107.1.114.114.3.31c.35.363.488.607.564.875.076.267.072.54-.014.805-.073.227-.19.434-.452.71l-.143.144-1.581 1.529v-.003l-2.185 2.11ZM24.06 15.931a8.128 8.128 0 0 1 8.129 8.102l-.476.458-1.544-1.6c-.65-.673-1.296-1.11-2.098-1.369a4.38 4.38 0 0 0-2.552-.044c-.708.201-1.302.544-1.891 1.062l-.252.233-.31.3c-.675.65-1.112 1.296-1.37 2.097a4.38 4.38 0 0 0-.045 2.552c.201.71.544 1.303 1.063 1.892l.233.252 1.544 1.6-.743.715-.015.001a8.128 8.128 0 0 1-7.802-8.122 8.128 8.128 0 0 1 8.129-8.13Z",
      clipRule: "evenodd"
    }
  )
);
var SvgRecordingOffOutlined = styled(SvgComponent)`
  ${size}
  ${color}
`;
var RecordingOffOutlined_default = SvgRecordingOffOutlined;

export { RecordingOffOutlined_default as default };
